var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"api-endpoints\">\n<div class=\"left-nav\">\n<div class=\"options-group\" ng-repeat=\"(label,options) in apiEndpointsCtrl.groupedOptions\">\n<div class=\"api-label\">{{label}}</div>\n<a class=\"api-option\" ng-repeat=\"opt in options\" ng-click=\"apiEndpointsCtrl.optionClicked(opt)\">\n<i class=\"fa fa-angle-double-right\"></i> {{opt.short_label}}</a>\n</div>\n</div>\n<div>\n<div ng-show=\"apiEndpointsCtrl._toRender\">\n<div hljs hljs-source=\"apiEndpointsCtrl._toRender\"></div>\n</div>\n</div>\n</div>";
var id1="components/api-endpoints/api-endpoints.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/api-endpoints/api-endpoints.template.html
// module id = 1257
// module chunks = 0